<template>
  <div
    style="position: relative"
    class="pallet-rack-sector--component"
  >
    <div
      v-for="index in Number(sector.sectionCount)"
      :key="index"
      style="position: absolute"
      class="pallet-rack-section-container"
    >
      <div :style="{ fontSize: size + 'px', position: 'relative' }">
        <div
        id="sectorHeader"
          data-cy="section-group-tag-b"
          :style="{
            height: '24px',
            justifyContent: 'center',
            position: 'absolute',
            top: '4px',
            left: mmToEm(
              +includeImpactProtectors ? 235 : 0 + selectedUprights.width / 2
            ),
            width: mmToEm(
              (sector.beam.length + selectedUprights.width) *
                Number(sector.sectionCount)
            ),
            backgroundColor: sector.backgroundColor,
            color: sector.textColor
          }"
        >
          <div
            style="font-size: 13px; font-weight: 800; margin-top:2px; width: inherit; display: flex; flex-direction: row; justify-content: inherit; padding-left: 0.25em; padding-right: 0.25em"
          >
            <div style="overflow: hidden; text-overflow: ellipsis">
              Sektionsgrupp
            </div>
            <div>&nbsp;{{ sector.index + 1 }}</div>
          </div>
        </div>
      </div>
      <pallet-rack-section
        :index="index - 1"
        :sector="sector"
        :size="size"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PalletRackSection from "@/components/PalletRackSection.vue";

export default {
  components: {
    PalletRackSection
  },

  props: {
    // eslint-disable-next-line vue/require-default-prop
    sector: Object,
    // eslint-disable-next-line vue/require-default-prop
    levels: Number,
    // eslint-disable-next-line vue/require-default-prop
    size: [String, Number]
  },
  computed: {
    ...mapState(["sectors", "selectedUprights", "includeImpactProtectors"]),
    isLeftmost() {
      if (this.sector && this.sectors) {
        return this.sector.index == 0
      }
      return false
    },

    isRightmost() {
      if (this.sector && this.sectors) {
        return this.sector.index == this.sectors.length - 1;
      }
      return false
    }
  },
  methods: {
    mmToEm(mm) {
      return mm / 1000 + "em";
    }
  }
};
</script>
